/**
 * <summary>
 * formik form to upload or update Headquarter after and before medical templates.
 * store can choose from uploaded templates.
 * </summary>
 */
import { Form, Formik, Field } from "formik";
import { Col, Row } from "react-bootstrap";
import Label from "../../../shared-components/label/label";
import LoaderButton from "../../../shared-components/button/loader-button";
import {IUpdateHeadquarterTemplate } from "../../../models/response/IHeadquarterResponse";
import FormikFormUploadImages from "../../../shared-components/FormikFormHandlers/FormikFormUploadImages";
import { FormattedMessage } from "react-intl";
import { templateImageValidateSchema } from "../../../shared-components/FormikFormHandlers/FormikValidationSchema";
import { IObservableInitialState } from "../../../models/ICommon";
import { useEffect, useState, useRef } from "react";
import { observer } from "mobx-react";

interface IProps {
  id: number;
  submitHandler: (data: IUpdateHeadquarterTemplate) => void;
  loading: boolean;
  initialValues: any;
  isUpdateMode: boolean;
  disableAction: boolean;
  addUpdateHeadquarterTemplateState: IObservableInitialState;
}

const AddEditUploadTemplatesForm = (props: IProps) => {
  const [resetFormValues, setResetFormValues] = useState<(() => void) | null>(null);

  const hasReset = useRef(false);

  useEffect(() => {
    if (props.addUpdateHeadquarterTemplateState.success && resetFormValues && !hasReset.current) {
      resetFormValues();
      hasReset.current = true; // prevent further resets
    } else if (!props.addUpdateHeadquarterTemplateState.success) {
      hasReset.current = false; // allow reset again on next success
    }
  }, [props.addUpdateHeadquarterTemplateState.success, resetFormValues]);

  return (
    <Formik
      initialValues={props.initialValues}
      enableReinitialize
      validationSchema={templateImageValidateSchema}
      validateOnBlur={false}
      onSubmit={async (values, { resetForm }) => {
        setResetFormValues(() => resetForm);
        props.submitHandler(values);
      }}
    >
      {({ values }) => (
        <Form className="setting-form" noValidate>
          <Row className="position-relative">
            <Col xs={12} md={12}>
              <h3 className="mb-0">
                <FormattedMessage id="upload_before_templates" />
              </h3>
            </Col>

            <Col sm={6}>
              <Field
                className="form-control"
                name="TemplateBeforeOne"
                type="text"
                as={FormikFormUploadImages}
                isConvertImageToBase64={true}
              />
            </Col>
            <Col sm={6}>
              <Field
                className="form-control"
                name="TemplateBeforeTwo"
                type="text"
                as={FormikFormUploadImages}
                isConvertImageToBase64={true}
              />
            </Col>

            <Col xs={12} md={12}>
              <h3 className="mb-0 mt-3">
                <FormattedMessage id="upload_after_templates" />
              </h3>
            </Col>

            <Col sm={6}>
              <Field
                className="form-control"
                name="TemplateAfterOne"
                type="text"
                as={FormikFormUploadImages}
                isConvertImageToBase64={true}
              />
            </Col>
            <Col sm={6}>
              <Field
                className="form-control"
                name="TemplateAfterTwo"
                type="text"
                as={FormikFormUploadImages}
                isConvertImageToBase64={true}
              />
            </Col>

            <Col xs={12} md={12}>
              <LoaderButton
                type="submit"
                className="mt-3"
                isLoading={props.loading}
                disabled={
                  ((values.TemplateBeforeOne == null || values.TemplateBeforeOne == "") &&
                  (values.TemplateBeforeTwo == null || values.TemplateBeforeTwo == "") &&
                  (values.TemplateAfterOne == null || values.TemplateAfterOne == "") &&
                  (values.TemplateAfterTwo == null || values.TemplateAfterTwo == "") &&
                  !(
                    props.initialValues?.TemplateBeforeOne || props.initialValues?.TemplateBeforeTwo ||
                    props.initialValues?.TemplateAfterOne || props.initialValues?.TemplateAfterTwo
                  )
                    ? true
                    : false) || props.disableAction
                }
                text={
                  props.initialValues?.TemplateBeforeOne
                    ? "button_update"
                    : "button_save"
                }
              />
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};

export default observer(AddEditUploadTemplatesForm);
